import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import TruncatedTextWithTooltip from "../../../../common-components/TruncatedText/TruncatedTextWithTooltip";

export const StyledTopCompanyInfoItem = styled(Flex)`
    gap: 4px;
    align-items: center;
    max-width: 100%;
    height: 21px;
    padding: 0 8px;
    border-radius: 4px;
    background: ${colorsPalettes.carbon[25]};
`;

export const StyledTopCompanyInfoItemText = styled(TruncatedTextWithTooltip)`
    font-size: 10px;
    font-style: normal;
    line-height: normal;
    color: ${colorsPalettes.carbon[500]};
`;

export const StyledTopCompanyInfoIcon = styled(SWReactIcons)`
    svg * {
        fill: ${colorsPalettes.carbon[400]};
    }
`;
